

window.addEventListener("load", function () {
    const tabItems = document.querySelectorAll('#pwm-ld-25-bigupdate-update .tab-item');
    const tabContents = document.querySelectorAll('#pwm-ld-25-bigupdate-update .tab-content > div');

    tabItems.forEach((tabItem, index) => {
        tabItem.addEventListener('click', function() {
            // Remove active class from all tabs and contents
            tabItems.forEach(item => item.classList.remove('active'));
            tabContents.forEach(content => content.classList.remove('active'));

            // Add active class to clicked tab
            this.classList.add('active');

            // Show corresponding content
            const tabNumber = this.getAttribute('data-tab');
            const targetContent = document.querySelector(`#pwm-ld-25-bigupdate-update .tab-content-${tabNumber}`);
            if (targetContent) {
                targetContent.classList.add('active');
            }
        });
    });
});
